// 3 text column
(() => {
  const threeTextColumn = document.querySelectorAll('[data-swiper-3-text-col]');

  threeTextColumn.forEach((el) => {

    const swiper = el.querySelector('.swiper');
    const pagination = el.querySelector('[data-swiper-pagination]');

    if(!swiper) {
      return;
    }

    const options = {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { 
          enabled: true,
          slidesPerView: 2, 
          spaceBetween: 20 
        },
        1024: { 
          enabled: false,
          slidesPerView: 3, 
          spaceBetween: 30 
        },
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
    };

    if(pagination) {
      options.pagination = {
        clickable: true,
        el: pagination,
      }
    }

    new Swiper(swiper, options);
  });

})();


// steps
(() => {
  const steps = document.querySelectorAll('[data-swiper-steps]');

  steps.forEach((el) => {

    const swiper = el.querySelector('.swiper');
    const pagination = el.querySelector('[data-swiper-pagination]');
    const numSlides = swiper.querySelectorAll('.swiper-slide').length;

    if(!swiper) {
      return;
    }

    const options = {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { 
          enabled: true,
          slidesPerView: 1, 
          spaceBetween: 0 
        },
        1024: { 
          enabled: false,
          slidesPerView: numSlides, 
          spaceBetween: 0 
        },
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
    };

    if(pagination) {
      options.pagination = {
        clickable: true,
        el: pagination,
      }
    }

    new Swiper(swiper, options);
  });

})();


// workflow
(() => {
  const workflows = document.querySelectorAll('[data-swiper-workflow]');

  workflows.forEach((el) => {

    const swiper = el.querySelector('.swiper');
    const pagination = el.querySelector('[data-swiper-pagination]');
    const numSlides = swiper.querySelectorAll('.swiper-slide').length;

    if(!swiper) {
      return;
    }

    const options = {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { 
          enabled: true,
          slidesPerView: 1, 
          spaceBetween: 20 
        },
        1024: { 
          enabled: false,
          slidesPerView: numSlides, 
          spaceBetween: 0 
        },
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
    };

    if(pagination) {
      options.pagination = {
        clickable: true,
        el: pagination,
      }
    }

    new Swiper(swiper, options);
  });

})();


// testimonials
(() => {
  const testimonials = document.querySelectorAll('[data-swiper-testimonials]');

  testimonials.forEach((el) => {

    const key = el.dataset.swiperTestimonials;
    const swiper = el.querySelector('.swiper');
    const navPrev = document.querySelector(`[data-swiper-testimonials-nav-prev="${key}"]`);
    const navNext = document.querySelector(`[data-swiper-testimonials-nav-next="${key}"]`);

    if(!swiper) {
      return;
    }

    const options = {
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      breakpoints: {
        1024: { 
          slidesPerView: 1.7
        },
      },
      centeredSlides: false,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,
    };

    if(navPrev && navNext) {
      options.navigation = {
        nextEl: navNext,
        prevEl: navPrev,
      };
    }

    new Swiper(swiper, options);
  });

})();



// two sliders
(() => {
  const twoSliders = document.querySelectorAll('[data-two-sliders]');

  twoSliders.forEach((main) => {
    // image
    const imageSliderEl = main.querySelector('[data-two-sliders-image] .swiper');
    let imageSlider = null;

    if(imageSliderEl) {
      const imageSliderElOption = {
        // allowTouchMove: false,
        effect: "cards",
        grabCursor: true,
      };

      imageSlider = new Swiper(imageSliderEl, imageSliderElOption);
    }

    // text
    const textSliderEl = main.querySelector('[data-two-sliders-text] .swiper');
    const pagination = main.querySelector('[data-swiper-pagination]');

    if(textSliderEl) {
      const textSliderOption = {
        loop: true,
        slidesPerView: 1,
      };

      if(pagination) {
        textSliderOption.pagination = {
          clickable: true,
          el: pagination,
        }
      }

      if(imageSlider) {
        textSliderOption.on = {
          slideChange: (swiper, q) => {
            imageSlider.slideTo(swiper.realIndex);
          }
        }
      }

      new Swiper(textSliderEl, textSliderOption);
    }

  });

})();


// services
(() => {
  const services = document.querySelectorAll('[data-swiper-services]');

  services.forEach((el) => {

    const swiper = el.querySelector('.swiper');
    const pagination = el.querySelector('[data-swiper-pagination]');

    if(!swiper) {
      return;
    }

    const options = {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { 
          enabled: true,
          slidesPerView: 1, 
          spaceBetween: 20 
        },
        1024: { 
          enabled: true,
          slidesPerView: 2, 
          spaceBetween: 30 
        },
        1280: { 
          enabled: false,
          slidesPerView: 3, 
          spaceBetween: 24 
        },
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
    };

    if(pagination) {
      options.pagination = {
        clickable: true,
        el: pagination,
      }
    }

    new Swiper(swiper, options);
  });
})();


// roles carousel
(() => {
  const roles = document.querySelectorAll('[data-swiper-roles]');

  roles.forEach((el) => {

    const key = el.dataset.swiperRoles;
    const swiper = el.querySelector('.swiper');
    const navPrev = document.querySelector(`[data-swiper-roles-nav-prev="${key}"]`);
    const navNext = document.querySelector(`[data-swiper-roles-nav-next="${key}"]`);

    if(!swiper) {
      return;
    }

    const options = {
      breakpoints: {
        480: { slidesPerView: 1.5, centeredSlides: true },
        580: { slidesPerView: 3, centeredSlides: false },
        800: { slidesPerView: 4, centeredSlides: false },
        1024: { slidesPerView: 5, centeredSlides: false },
        1280: { slidesPerView: 6, centeredSlides: false },
        1540: { slidesPerView: 7, centeredSlides: false },
      },
      centeredSlides: true,
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 16,
    };

    if(navPrev && navNext) {
      options.navigation = {
        nextEl: navNext,
        prevEl: navPrev,
      };
    }

    new Swiper(swiper, options);
  });

})();
